import { useQuery } from 'react-query';
import { getAllTimeLeaderboardQuery, getContestById, getContestsQuery } from 'src/apis/contest';
import {
	ContestTemplateFilterInputs,
	GetUIContestsAPIResponse,
	GetUIContestByIdAPIResponse,
	GetAllTimeLeaderboardAPIResponse,
} from 'types';

export const useGetContests = (
	payload?: ContestTemplateFilterInputs,
	onComplete?: (data: GetUIContestsAPIResponse) => void,
	onSettled?: () => void,
) => {
	return useQuery({
		queryKey: ['getContestsQuery', payload],
		queryFn: async () => (await getContestsQuery(payload)) as GetUIContestsAPIResponse,
		staleTime: 0,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onSettled: () => {
			onSettled && onSettled();
		},
	});
};

export const useGetContestById = ({
	id,
	payload,
	onComplete,
	onSettled,
	onError,
}: {
	id: string;
	payload?: ContestTemplateFilterInputs;
	onComplete?: (data: GetUIContestByIdAPIResponse) => void;
	onSettled?: () => void;
	onError?: (err: unknown) => void;
}) => {
	return useQuery({
		queryKey: ['getContestById', payload],
		queryFn: async () => (await getContestById({ id, payload })) as GetUIContestByIdAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onSettled: () => {
			onSettled && onSettled();
		},
		onError: err => {
			onError && onError(err);
		},
	});
};

export const useAllTimeLeaderboard = (
	onComplete?: (data: GetAllTimeLeaderboardAPIResponse) => void,
	onSettled?: () => void,
) => {
	return useQuery({
		queryKey: ['getAllTimeLeaderboardQuery'],
		queryFn: async () => (await getAllTimeLeaderboardQuery()) as GetAllTimeLeaderboardAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onSettled: () => {
			onSettled && onSettled();
		},
	});
};
